var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m85.736 27.671-.025-.015L50.727 8.289a1.501 1.501 0 0 0-1.477.014L14.264 28.502a1.5 1.5 0 0 0-.75 1.299v40.398a1.5 1.5 0 0 0 .75 1.299l34.986 20.2a1.499 1.499 0 0 0 1.5 0l34.986-20.2a1.5 1.5 0 0 0 .75-1.299v-41.23a1.5 1.5 0 0 0-.75-1.299Zm-35.72-16.347 31.923 17.673-8.48 4.896-31.671-17.818 8.228-4.75ZM31.339 22.108l31.67 17.818L50 47.436 18.733 29.385l12.605-7.278Zm-14.825 9.459L48.5 50.034V87.8L16.514 69.332V31.567Zm66.973 37.766L51.501 87.801V50.034l12.273-7.086v19.156l10.446-6.035V36.917l9.268-5.351v37.766Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.76 66.29 5.579 3.078v-7.695l-5.579-3.078v7.695zm8.45-3.078v7.694l5.579 3.078V66.29l-5.579-3.078z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.60da5d4aaf7fb70df639b767cf5c18ec.svg";
export { ForwardRef as ReactComponent };